<template>
  <div id="app">
    <div id="nav">
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    </div>
    <router-view/>
  </div>
</template>


<script>

// @ is an alias to /src

export default {
  name: 'app'
}

</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #dcc397;
}

#nav {
  background-color: white;
}

#nav a {
  font-weight: bold;
  color: #dcc397;
}

#nav a.router-link-exact-active {
  color: #dcc397;
}

body {
background-color: #F8F8F8;
/* F8ckground-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 400'%3E%3Cdefs%3E%3CradialGradient id='a' cx='396' cy='281' r='514' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23ffffff'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='400' y1='148' x2='400' y2='333'%3E%3Cstop offset='0' stop-color='%232a93ac' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%232a93ac' stop-opacity='0.5'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='400'/%3E%3Cg fill-opacity='0.4'%3E%3Ccircle fill='url(%23b)' cx='267.5' cy='61' r='300'/%3E%3Ccircle fill='url(%23b)' cx='532.5' cy='61' r='300'/%3E%3Ccircle fill='url(%23b)' cx='400' cy='30' r='300'/%3E%3C/g%3E%3C/svg%3E"); */
background-attachment: fixed;
background-size: cover;
}

a {
  color: #dcc397;
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

.uk-button-primary {
  background-color: #dcc397;  
}

.uk-button-primary:hover {
  background-color: #dcc390;  
}

.uk-button-primary:focus {
  background-color: #dcc397;  
}

.uk-progress {
  color: #2c3e50;  
}

.uk-button-danger {
  background-color:red;  
}

.uk-button-danger:hover {
  background-color:red;  
}

.uk-input:focus {
  border-color: #dcc397;
}


</style>
